/**
 * animator.tsx
 */
import CONFIG from './config';
import Viewport from './viewport';
import { AnimatorProps, AnimatorType } from './types';
import { HorizontalLayer, VerticalLayer } from './layers';

/**
 * Fixed, opacity-animated content box used at the top of pages/sections.
 * Passing `type` selects a preset (see config.ts) that wraps children in
 * one or two collapse-driven translateX/Y layers; `collapse` supplies the
 * runtime state driving each axis.
 */
function Animator({
  type,
  collapse,
  containerProps,
  children,
  ...rest
}: React.PropsWithChildren<AnimatorProps>) {
  const config = type !== undefined ? CONFIG[type] : undefined;
  let content = children;

  if (config?.vertical) {
    const { style, ...handlers } = containerProps?.vertical ?? {};
    content = (
      <VerticalLayer
        axis={{ ...config.vertical, collapse: collapse?.vertical }}
        {...handlers}
        style={{ ...config.vertical.style, ...style }}
      >
        {content}
      </VerticalLayer>
    );
  }

  if (config?.horizontal) {
    const { style, ...handlers } = containerProps?.horizontal ?? {};
    content = (
      <HorizontalLayer
        axis={{ ...config.horizontal, collapse: collapse?.horizontal }}
        {...handlers}
        style={{ ...config.horizontal.style, ...style }}
      >
        {content}
      </HorizontalLayer>
    );
  }

  return (
    <Viewport style={config?.style} {...rest}>
      {content}
    </Viewport>
  );
}

Animator.Type = AnimatorType;
export default Animator;
